import { hydrateMappedForm, serializeMappedForm } from "./formAdapter";

const fields = [
  ["codigoBeneficiario", "identidad.codigo", "text"],
  ["valueCedula", "identidad.cedula", "text"],
  ["valueNombre", "identidad.nombre", "text"],
  ["valueApellido", "identidad.apellido", "text"],
  ["sexoBenef", "identidad.sexo", "text"],
  ["valueGenero", "identidad.genero", "text"],
  ["fechaNacSalud", "identidad.fechaNacimiento", "date"],
  ["telefono", "identidad.telefono", "text"],
  ["valueRep", "identidad.nombreRepresentante", "text"],
  ["valueApellidoRep", "identidad.apellidoRepresentante", "text"],
  ["lgbtqi", "identidad.lgbtqi", "text"],
  ["codigoGrupoEtnico", "identidad.grupoEtnicoId", "id"],
  ["codigoDisc", "identidad.discapacidadId", "id"],
  ["codigoMovilidad", "identidad.movilidadId", "id"],
  ["factorRiesgoIds", "identidad.factoresRiesgoIds", "idList"],
  ["codigoNivelEducativo", "identidad.nivelEducativoId", "id"],
  ["cabezaFamilia", "identidad.cabezaFamilia", "text"],
  ["ingresosPropios", "identidad.ingresos", "text"],
  ["fechaActSalud", "salud.fechaAtencion", "date"],
  ["estadoSalud", "salud.estado", "text"],
  ["municipioSalud", "salud.municipio", "text"],
  ["parroquiaSalud", "salud.parroquia", "text"],
  ["estSalud", "salud.centro", "text"],
  ["comunidadSalud", "salud.comunidad", "text"],
  ["data", "salud.motivosConsulta", "motives"],
  ["data3", "salud.diagnosticos", "diagnoses"],
  ["tipoEnfermedadIds", "salud.tipoEnfermedadIds", "idList"],
  ["comentAdicionales", "salud.comentarios", "text"],
  ["medicoId", "salud.medicoId", "id"],
  ["tratamiento", "salud.tratamientos.indicados", "treatments"],
  ["edadEnMeses", "m5.edadMeses", "number"],
  ["edema", "m5.edema", "text"],
  ["cmbM5", "m5.cmb", "number"],
  ["pbM5", "m5.clasificacionPb", "text"],
  ["pesoM5", "m5.peso", "number"],
  ["tallaM5", "m5.talla", "number"],
  ["puntajezM5", "m5.puntajeZ", "number"],
  ["clasificacionNutM5", "m5.clasificacionNutricional", "text"],
  ["diagFinalM5", "m5.diagnosticoIngreso", "text"],
  ["consejM5", "m5.consejeria", "text"],
  ["referidoM5", "m5.referido", "text"],
  ["albendazolM5", "m5.albendazol", "text"],
  ["micronutM5", "m5.micronutrientes", "text"],
  ["lnsmq", "m5.lnsMq", "text"],
  ["rutfM5", "m5.rutf", "text"],
  ["amoxM5", "m5.amoxicilina", "text"],
  ["kitHigieneM5", "m5.kitHigiene", "text"],
  ["albendazolDosisM5", "m5.dosisAlbendazol", "text"],
  ["condicionMujer", "mel.condicionMujer", "text"],
  ["semanasGestacion", "mel.semanasGestacion", "number"],
  ["tiempoLactancia", "mel.tiempoLactancia", "number"],
  ["pesoGL", "mel.peso", "number"],
  ["tallaGL", "mel.talla", "number"],
  ["pbGL", "mel.pb", "number"],
  ["imcGL", "mel.imc", "number"],
  ["diagIngresoGL", "mel.diagnosticoIngreso", "text"],
];

export function nutriFormSnapshot(ui) {
  return {
    ...ui,
    telefono: ui.tlf?.textmask || "",
    medicoId: ui.value?.id || "",
    factorRiesgoIds: [ui.codigoFactoresRiesgo, ui.codigoFactoresRiesgo2, ui.codigoFactoresRiesgo3].filter(Boolean),
    tipoEnfermedadIds: ui.tipoEnfermedadIds ?? [ui.codigoTipoEnf, ui.codigoTipoEnf2].filter(Boolean),
    semanasGestacion: ui.semanasGestacion === "" ? "" : parseInt(ui.semanasGestacion, 10),
  };
}

export function serializeFormToV2Data(snapshot, original, baseline) {
  const calculated = new Set(["edadEnMeses", "pbM5", "clasificacionNutM5", "diagFinalM5", "imcGL", "diagIngresoGL"]);
  const extras = {
    factorRiesgoIds: original?.identidad?.factoresRiesgoIds?.slice(3) || [],
  };
  const withExtras = (ui = {}) => ({ ...ui,
    factorRiesgoIds: [...(ui.factorRiesgoIds || []), ...extras.factorRiesgoIds],
  });
  return serializeMappedForm(withExtras(snapshot), fields.filter(([key]) => !calculated.has(key)), original, withExtras(baseline));
}

export function hydrateV2DataToForm(datos) {
  const ui = hydrateMappedForm(datos, fields);
  return {
    ...ui,
    tlf: { textmask: ui.telefono },
    value: ui.medicoId ? { id: ui.medicoId } : null,
    codigoFactoresRiesgo: ui.factorRiesgoIds[0] || "",
    codigoFactoresRiesgo2: ui.factorRiesgoIds[1] || "",
    codigoFactoresRiesgo3: ui.factorRiesgoIds[2] || "",
    codigoTipoEnf: ui.tipoEnfermedadIds[0] || "",
    codigoTipoEnf2: ui.tipoEnfermedadIds[1] || "",
    semanasGestacion: ui.semanasGestacion === "" ? "" : `${ui.semanasGestacion} Semana${ui.semanasGestacion === 1 ? "" : "s"}`,
  };
}
